import React, { useState } from "react";
import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, TextField, InputAdornment } from "@mui/material";
import { EmailOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useResetPasswordMutation } from "../../services/auth";

const formatAuthError = (err: any, defaultMsg: string): string => {
  if (err?.data) {
    return typeof err.data === 'string' ? err.data : JSON.stringify(err.data);
  }
  if (err?.error) {
    return typeof err.error === 'string' ? err.error : (JSON.stringify(err.error) || String(err.error));
  }
  if (err?.message) {
    return typeof err.message === 'string' ? err.message : String(err.message);
  }
  return defaultMsg;
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState<{ email?: string }>({});
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const email = (formData.get("email") as string || "").toLowerCase().trim();

    setErrors({});

    if (!email) {
      setErrors({ email: "Email is required" });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrors({ email: "Please enter a valid email address" });
      return;
    }

    try {
      const payload = { email };
      await resetPassword(payload).unwrap();
      toast.success("OTP sent to your email!");
      navigate("/otp", { state: { email, signupMethod: "email", flow: "forgot_password" } });
    } catch (err: any) {
      console.error("Reset Password API Error:", err);
      toast.error(formatAuthError(err, "Failed to send reset link"));
    }
  };

  return (
    <AuthLayout
      subtitle="Trouble logging in?"
      title={<React.Fragment>Let's get your  <span style={{ color: "#8CE352" }}>Account</span>   back.</React.Fragment>}
    >
      <div className="authBox">
        <h2 style={{ position: "relative" }}>
          <img
            src="/static/images/back_arrow.svg"
            alt="back"
            onClick={() => navigate(-1)}
            className="back_arrow"
            style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", cursor: "pointer", width: 24, height: 24 }}
          />
          Forgot Password?
        </h2>
        <p className="subtitle" style={{ marginBottom: 40 }}>
          Enter your email to request a reset link
        </p>

        <form className="form" onSubmit={handleSubmit}>
          <div className="control_group text_field">
            <label htmlFor="email">Email Address</label>
            <TextField
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email address"
              fullWidth
              onChange={(e) => { e.target.value = e.target.value.toLowerCase(); }}
              onBlur={(e) => { e.target.value = e.target.value.toLowerCase().trim(); }}
              error={!!errors.email}
              helperText={errors.email}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlined style={{ color: "rgba(255, 255, 255, 0.4)" }} />
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div className="form_btn" style={{ marginTop: 30 }}>
            <Button
              type="submit"
              className="btn btn_primary w_100"
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Reset Password"}
            </Button>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
